<template>
    <div style="padding: 10px;color: black;">
        <div>
            <img src="../assets/bg.jpg" style="width: 100%" alt="">
        </div>
        <div style="margin-top: 10px">
            <div v-for="(item,index) in list" style="margin-bottom: 10px" :key="index">
                <el-card>
                    <el-form :model="item" ref="queryForm" size="mini" label-position="left"
                             label-width="68px">
                        <el-form-item label="参赛号码" prop="contestNumber">
                            <el-input v-model="item.contestNumber" readonly placeholder="暂无参赛号码"/>
                        </el-form-item>
                        <el-form-item label="参赛选手" prop="participantName">
                            <el-input v-model="item.participantName" readonly placeholder="暂无参赛选手"/>
                        </el-form-item>
                        <el-form-item label="年级" prop="grade">
                            <el-input v-model="item.grade" readonly placeholder="暂无年级"/>
                        </el-form-item>
                        <el-form-item label="参赛专业" prop="major">
                            <el-input v-model="item.major" readonly placeholder="暂无参赛专业"/>
                        </el-form-item>
                        <el-form-item label="参赛形式" prop="contestForm">
                            <el-input v-model="item.contestForm" readonly placeholder="暂无参赛形式"/>
                        </el-form-item>
                        <el-form-item label="作品名称" prop="workTitle">
                            <el-input v-model="item.workTitle" readonly placeholder="暂无作品名称"/>
                        </el-form-item>
                        <el-form-item label="签到时间" prop="checkInTime">
                            <el-input v-model="item.checkInTime" readonly placeholder="暂无签到时间"/>
                        </el-form-item>
                        <el-form-item label="参赛时间" prop="contestTime">
                            <el-input v-model="item.contestTime" readonly placeholder="暂无参赛时间"/>
                        </el-form-item>
                        <el-form-item label="组序" prop="groupOrder">
                            <el-input v-model="item.groupOrder" readonly placeholder="暂无组序"/>
                        </el-form-item>
                        <el-form-item label="日期" prop="date">
                            <el-input v-model="item.date" readonly placeholder="暂无日期"/>
                        </el-form-item>
                        <el-form-item label="会场" prop="venue">
                            <el-input v-model="item.venue" readonly placeholder="暂无会场"/>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "SelectPage2",
    data() {
        return {
            /**
             id: null,
             contestNumber: null,
             participantName: null,
             grade: null,
             major: null,
             contestForm: null,
             workType: null,
             workTitle: null,
             checkInTime: null,
             contestTime: null,
             groupOrder: null,
             date: null,
             createTime: null,
             venue: null,
             */
            list: [],
        }
    },
    created() {
        document.title = this.$route.meta.title;
        console.log(this.$route.query)
        this.list = JSON.parse(this.$route.query.data);
    },
    mounted() {

    },
    methods: {}
}
</script>

<style>
.el-input {
    height: inherit;
}
</style>
